import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonLibModule } from 'icc-common-lib';
import { TikTokChannelEditComponent } from './component/tikok-channel/edit/edit.component';
import { TikTokChannelViewComponent } from './component/tikok-channel/view/view.component';
import { TiktokEditorComponent } from './component/tiktok-editor/tiktok-editor.component';
import { TiktokFansManageComponent } from './component/tiktok-fans-manage/tiktok-fans-manage.component';
import { TiktokMobilePreviewComponent } from './component/tiktok-mobile-preview/tiktok-mobile-preview.component';
import { TiktokModalDetailComponent } from './component/tiktok-modal-detail/tiktok-modal-detail.component';
import { SocialTiktokComponent } from './component/tiktok-social/social-tiktok.component';
import { TiktokAccountComponent } from './component/tiktok-social/tiktok-account/tiktok-account.component';
import { TiktokAnalyzeComponent } from './component/tiktok-social/tiktok-analyze/tiktok-analyze.component';
import { ActiveDaysComponent } from './component/tiktok-social/tiktok-fans/active-days/active-days.component';
import { FansAgeComponent } from './component/tiktok-social/tiktok-fans/fans-age/fans-age.component';
import { FansAreaComponent } from './component/tiktok-social/tiktok-fans/fans-area/fans-area.component';
import { FansGenderComponent } from './component/tiktok-social/tiktok-fans/fans-gender/fans-gender.component';
import { FansInterestComponent } from './component/tiktok-social/tiktok-fans/fans-interest/fans-interest.component';
import { TiktokFansTrendComponent } from './component/tiktok-social/tiktok-fans/tiktok-fans-trend/tiktok-fans-trend.component';
import { TiktokDataTrendComponent } from './component/tiktok-social/video/tiktok-data-trend/tiktok-data-trend.component';
import { VideoPublishFrequencyComponent } from './component/tiktok-social/video/video-publish-frequency/video-publish-frequency.component';
import { VideoStatisticsComponent } from './component/tiktok-social/video/video-statistics/video-statistics.component';
import { VideoComponent } from './component/tiktok-social/video/video.component';
import { TiktokTimelineContentComponent } from './component/tiktok-timeline-content/tiktok-timeline-content.component';
import { TiktokTplAuditComponent } from './component/tiktok-tpl-audit/tiktok-tpl-audit.component';
import { TiktokTplAutoMatchComponent } from './component/tiktok-tpl-auto-match/tiktok-tpl-auto-match.component';
import { TiktokTplDetailComponent } from './component/tiktok-tpl-detail/tiktok-tpl-detail.component';
import { TiktokTplEditComponent } from './component/tiktok-tpl-edit/tiktok-tpl-edit.component';
import { SendDetailTiktokCommentComponent } from './component/tiktok-sendDetail/comment/comment.component';
import { SendDetailTiktokGroupSendComponent } from './component/tiktok-sendDetail/groupSend/groupSend.component';
import { SendDetailTiktokMessageComponent } from './component/tiktok-sendDetail/message/message.component';
import { SendDetailTiktokListComponent } from './component/tiktok-sendDetail/tiktokList.component';
import { TiktokFansComponent } from './component/tiktok-social/tiktok-fans/tiktok-fans.component';
import { CommentTiktokComponent } from './component/tiktok-comment/tiktok.component';
import { TikTokLeaveMessageComponent } from './component/tiktok-comment/leave-message/leave-message.component';
import { TikTokCommentComponent } from './component/tiktok-comment/comment/comment.component';
import { TiktokConstraintKeywordComponent } from './component/tiktok-constraint-keyword/tiktok.component';
import { TiktokConstraintKeywordImportExportComponent } from './component/tiktok-constraint-keyword/import-export/import-export.component';
import { TiktokConstraintKeywordEditComponent } from './component/tiktok-constraint-keyword/edit/edit.component';
import { DatePipe } from '@angular/common';

// 自定义组件
const COMPONENTS = [
  TiktokEditorComponent,
  TiktokMobilePreviewComponent,
  TiktokModalDetailComponent,
  TiktokTimelineContentComponent,
  TiktokTplAuditComponent,
  TiktokTplAutoMatchComponent,
  TiktokTplDetailComponent,
  TiktokTplEditComponent,
  // 社交运营分析
  SocialTiktokComponent,
  VideoComponent,
  VideoStatisticsComponent,
  VideoPublishFrequencyComponent,
  TiktokDataTrendComponent,
  TiktokFansTrendComponent,
  FansInterestComponent,
  FansGenderComponent,
  FansAreaComponent,
  FansAgeComponent,
  ActiveDaysComponent,
  TiktokAnalyzeComponent,
  TiktokAccountComponent,
  TiktokFansComponent,
  // 发送详情
  SendDetailTiktokListComponent,
  SendDetailTiktokMessageComponent,
  SendDetailTiktokGroupSendComponent,
  SendDetailTiktokCommentComponent,

  // 接收记录
  CommentTiktokComponent,
  TikTokLeaveMessageComponent,
  TikTokCommentComponent,

  //渠道管理
  TikTokChannelEditComponent,
  TikTokChannelViewComponent,
  //粉丝中心
  TiktokFansManageComponent,
  // 敏感字管控
  TiktokConstraintKeywordComponent,
  TiktokConstraintKeywordImportExportComponent,
  TiktokConstraintKeywordEditComponent
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [CommonLibModule, RouterModule],
  entryComponents: [...COMPONENTS],
  providers: [DatePipe],
  exports: [...COMPONENTS],
})
export class TiktokLibModule {}
